module.exports = __webpack_public_path__ + "static/img/92052A_1_C_20220721_fit.cab91f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92052A_1_C_20220721_fit.png
// module id = 3bV5
// module chunks = 0